<template>
	<div class="divider" :style="{ marginLeft: mx, marginRight: mx, marginTop: my, marginBottom: my }"></div>
</template>

<script>
export default {
	name: 'PHorizontalDivider',
	props: {
		mx: {
			default: () => '-20px',
		},
		my: {
			default: () => '20px',
		},
	},
};
</script>

<style lang="scss" scoped>
.divider {
	border-top: solid 1px #e9e9e9;
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/p-horizontal-divider.vue